import { useEffect, useState, useRef } from 'react';
import apiClient from '../../helpers/apiClient';

function useCampaign(url) {
  const [campaigns, setCampaigns] = useState(null);
  const [loadedCampaigns, setLoadedCampaigns] = useState(false);
  const isMounted = useRef(false);

  async function getCampaigns() {
    try {
      const res = await apiClient().get(url);

      if (isMounted.current) {
        setCampaigns(res);
        setLoadedCampaigns(true);
        return res.total_pages;
      }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    isMounted.current = true;
    getCampaigns();
    return () => {
      isMounted.current = false;
    };
  }, [url]);

  const { campaign_list: campaignList, total_pages: totalPages } = loadedCampaigns ? campaigns : {};
  return {
    campaignList,
    totalPages,
    loadedCampaigns,
    getCampaigns,
  };
}

export default useCampaign;
